import { Button, Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import dayjs from "dayjs"
import { DateString } from "@/utils/dateString"
import { showJpYen } from "@/utils/showJpYen"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"

const Row = ({ label, value }: { label: string; value: string }) => (
    <div
        css={css`
            display: grid;
            gap: 4px;
        `}
    >
        <Typography
            variant="caption"
            css={css`
                color: ${theme.palette.gray[600]};
            `}
        >
            {label}
        </Typography>
        <Typography
            css={css`
                word-break: break-all;
            `}
        >
            {value}
        </Typography>
    </div>
)

export const ConfirmStep = ({
    expenseDate,
    amount,
    routeDescription,
    submitting,
    onSubmit,
    onBack
}: {
    expenseDate: DateString
    amount: number
    routeDescription: string
    submitting: boolean
    onSubmit: () => void
    onBack: () => void
}) => {
    const { t } = useTranslation()

    return (
        <div
            css={css`
                display: grid;
                gap: 24px;
            `}
        >
            <Typography>{t("以下の内容で申請します")}</Typography>

            <div
                css={css`
                    display: grid;
                    gap: 16px;
                    padding: 16px;
                    background-color: white;
                    border: 1px solid ${theme.palette.gray[300]};
                    border-radius: 8px;
                `}
            >
                <Row
                    label={t("清掃日")}
                    value={dayjs(expenseDate).format("YYYY/MM/DD")}
                />
                <Row label={t("経路")} value={routeDescription} />
                <Row label={t("合計金額")} value={showJpYen(amount)} />
            </div>

            <Typography
                css={css`
                    color: ${theme.palette.intentions.secondary.main};
                `}
            >
                {t(
                    "申請内容は清掃日の翌日まで修正できます。申請の取り消しはできません"
                )}
            </Typography>

            <div
                css={css`
                    display: grid;
                    gap: 8px;
                `}
            >
                <Button
                    variant="filled"
                    color="primary"
                    onClick={onSubmit}
                    disabled={submitting}
                >
                    {submitting ? t("申請中...") : t("申請する")}
                </Button>
                <Button onClick={onBack} disabled={submitting}>
                    {t("修正する")}
                </Button>
            </div>
        </div>
    )
}
